module.exports = __webpack_public_path__ + "img/27.68cb6797.gif";